import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/pages/Home';
import QuienesSomos from './components/pages/QuienesSomos';
import Servicios from './components/pages/Servicios';
import Productos from './components/pages/Productos';
import Contacto from './components/pages/Contacto';
import WhatsAppButton from './components/WhatsAppButton';
import LoginAdmin from './components/admin/LoginAdmin';
import AdminPanel from './components/admin/AdminPanel';
import DashboardAdmin from './components/admin/DashboardAdmin';
import DashboardEditor from './components/admin/DashboardEditor';
import DashboardVendedor from './components/admin/DashboardVendedor';
import UsersPanel from './components/admin/UsersPanel';
import AdminLayout from './components/admin/AdminLayout';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<QuienesSomos />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/admin-login" element={<LoginAdmin />} />
            <Route path="/admin-productos" element={<AdminLayout><AdminPanel /></AdminLayout>} />
            <Route path="/admin-panel" element={<AdminLayout><AdminPanel /></AdminLayout>} />
            <Route path="/admin-usuarios" element={<AdminLayout><UsersPanel /></AdminLayout>} />
            <Route path="/admin" element={<AdminLayout><DashboardAdmin /></AdminLayout>} />
            <Route path="/editor" element={<AdminLayout><DashboardEditor /></AdminLayout>} />
            <Route path="/vendedor" element={<AdminLayout><DashboardVendedor /></AdminLayout>} />
          </Routes>
          <WhatsAppButton />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
